import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Pagination from '@material-ui/lab/Pagination';
import { Grid, useMediaQuery } from '@material-ui/core';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import { SectionWithArrows } from 'components/organisms';
import { WebService } from 'services';

import SearchForm from './components/SearchForm';
import SearchItem from './components/SearchItem';
import SearchNoDataFound from './components/SearchNoDataFound';

const webService = new WebService();

const useStyles = makeStyles(theme => ({
  root: {},
  pagination: {
    marginTop: theme.spacing(8),
    display: 'flex',
    justifyContent: 'center',
  },
  content: {
    height: '100%',
    minHeight: 420,
    '& > .section': {
      paddingTop: theme.spacing(6),
      [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(2),
      },
    },
  },
}));

const Search = props => {
  const { className, ...rest } = props; // eslint-disable-line no-unused-vars
  const classes = useStyles();
  const theme = useTheme();
  // eslint-disable-next-line no-unused-vars
  const history = useHistory();
  // eslint-disable-next-line no-unused-vars
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const [searchResult, setSearchResult] = useState({
    submitted: false,
    items: [],
  });
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useQueryParams({
    q: withDefault(StringParam, ''),
    page: withDefault(NumberParam, 1),
  });

  const { t } = useTranslation();

  useEffect(() => {
    setLoading(true);

    (async () => {
      const data = await webService.search(filters.q, filters.page);

      setSearchResult(data);
    })().finally(() => setLoading(false));
  }, [filters]);

  const handlePageChange = (event, value) => {
    setFilters(prev => ({ ...prev, page: value }));
  };

  const getItemUrl = item => {
    const url = webService.searchGenerateUrl(item);
    // history.push(url);
    return url;
  };

  const handleSearchChange = value => {
    setFilters(prev => ({
      ...prev,
      q: value,
      page: 1,
    }));
  };

  return (
    <div className={clsx(className)}>
      <SearchForm
        title={t('SEARCH.TITLE')}
        placeholder={t('SEARCH.PLACEHOLDER')}
        buttonText={t('SEARCH.BUTTON')}
        loading={loading}
        resultSummary={
          searchResult.submitted
            ? t('SEARCH.SUMMARY', {
                total: searchResult.total,
                keyword: filters.q,
              })
            : ''
        }
        defaultValue={filters.q}
        onChange={handleSearchChange}
      />
      <SectionWithArrows className={classes.content}>
        {searchResult.submitted && searchResult.total === 0 ? (
          <SearchNoDataFound />
        ) : (
          <>
            <Grid container>
              {searchResult.items.map((item, index) => (
                <Grid item xs={12} key={index}>
                  <SearchItem item={item} url={getItemUrl(item)} />
                </Grid>
              ))}
            </Grid>
            <div className={clsx(classes.pagination)}>
              <Pagination
                count={searchResult.pageTotal}
                page={filters.page}
                onChange={handlePageChange}
                size="large"
              />
            </div>
          </>
        )}
      </SectionWithArrows>
    </div>
  );
};

Search.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Search;
